module.exports = __webpack_public_path__ + "static/media/resetEn.ccef3c8f.jpg";